import { Form } from "react-bootstrap";
import "../style/style-register.css";
import { useState } from "react";
import axios from "../axios/axios";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";

export default function Inscrire() {
  const [civilite, setCivilite] = useState("");
  const [telephone, setTelephone] = useState("");
  const [nom, setNom] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [msg, setMsg] = useState("");

  const inscrire = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("civilite", civilite);
    form.append("telephone", telephone);
    form.append("nom", nom);
    form.append("email", email);
    form.append("password", password);

    axios
      .post("/inscrire", form, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        setMsg(response.data.msg);
        Swal.close();
      })
      .catch((error) => {
        console.log(error);
        Swal.close();
      });
  };

  return (
    <>
      {msg != "" ? (
        <div className="container mt-5">
          <div className="row bg-light">
            <div className="col-sm-12">
              <center>
                <h3 style={{ fontWeight: "900", padding: "10px" }}>
                  {msg == "ExistMail" ? (
                    <span>
                      Vous êtes déjà inscrit.{" "}
                      <Link
                        to={`${process.env.PUBLIC_URL}/profile`}
                        style={{ color: "red", textDecoration: "none" }}
                      >
                        Connecter vous
                      </Link>{" "}
                      pour consulter votre CV
                    </span>
                  ) : msg == "ErrerMail" ? (
                    <span>Email incorrecte; verifiez votre email</span>
                  ) : msg == "SuccessInscp" ? (
                    <span>
                      Un message de validation a été envoyé à votre email.
                    </span>
                  ) : null}
                </h3>
              </center>
            </div>
          </div>
        </div>
      ) : (
        <div id="section" className="signup mt-2">
          <div className="container card">
            <div className="row bg-light">
              <div className="col-sm-12">
                <center>
                  <h3 style={{ fontWeight: "900", padding: "10px" }}>
                    Inscrivez vous et gérer votre CV
                  </h3>
                  <p style={{ color: "black", fontWeight: "600" }}>
                    Si vous avez un compte
                    <Link
                      to={`${process.env.PUBLIC_URL}/consulter-voter-cv`}
                      style={{ color: "red", textDecoration: "none" }}
                    >
                      {" "}
                      cliquez ici{" "}
                    </Link>
                    pour connecter
                  </p>
                </center>
              </div>
            </div>

            <div className="signup-content">
              <Form
                id="signup-form"
                className="signup-form"
                onSubmit={inscrire}
              >
                <div className="row">
                  <div className="col-sm-2">
                    <label>Civilite</label>
                    <div className="select-list">
                      <select
                        name="civilite"
                        className="form-control form-input"
                        required
                        value={civilite}
                        onChange={(e) => setCivilite(e.target.value)}
                        style={{ height: "54px" }}
                      >
                        <option value="">-----</option>
                        <option value="Mr">Mr</option>
                        <option value="Mme">Mme</option>
                        <option value="Mlle">Mlle</option>
                      </select>
                    </div>
                  </div>

                  <div className="form-group col-sm-5">
                    <label>Telephone</label>
                    <input
                      type="number"
                      className="form-input"
                      value={telephone}
                      onChange={(e) => setTelephone(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-sm-5">
                    <label>Nom et prénom</label>
                    <input
                      type="text"
                      className="form-input"
                      value={nom}
                      onChange={(e) => setNom(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-sm-6">
                    <label>EMAIL</label>
                    <input
                      type="email"
                      required
                      className="form-input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-6">
                    <label>Password</label>
                    <input
                      type="password"
                      required
                      className="form-input"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>

                  <div className="form-group col-sm-12 ">
                    <button
                      type="submit"
                      className="btn "
                      style={{
                        borderRadius: "25px",
                        float: "right",
                        fontWeight: "900",
                        background: "#047104",
                        color: "#fff",
                      }}
                    >
                      S'Inscrire
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
